import { clsx } from '../../../../ds/clsx';
import { Pill, Tooltip } from '../../../../ds/components';
import { MODULE_OFF_TEXT, toolModuleActive, toolPillState, userToolItems, type UserTools } from './tools';
import styles from './UsersPage.module.css';

/**
 * The „Tools" cell of a user row: one compact pill per tool, accent when on, stone when off, dashed with the
 * tooltip „Modul aus" while the organization's module is off. Invitations have no tools yet („—").
 */
export function ToolPills({
  tools,
  modules,
}: {
  tools: UserTools | null | undefined;
  modules: readonly string[];
}) {
  if (tools === null || tools === undefined) return <span className={styles.toolsNone}>—</span>;
  return (
    <span className={styles.tools}>
      {userToolItems.map(({ key, label }) => {
        const state = toolPillState(tools[key], toolModuleActive(key, modules));
        const pill = (
          <Pill
            key={key}
            variant={state === 'on' ? 'accent' : 'neutral'}
            className={clsx(
              styles.toolPill,
              state === 'off' && styles.toolOff,
              state === 'module_off' && styles.toolModuleOff,
            )}
            data-state={state}
          >
            {label}
            {state === 'off' ? <span className={styles.visuallyHidden}> (aus)</span> : null}
            {state === 'module_off' ? (
              <span className={styles.visuallyHidden}> ({MODULE_OFF_TEXT})</span>
            ) : null}
          </Pill>
        );
        return state === 'module_off' ? (
          <Tooltip key={key} content={MODULE_OFF_TEXT}>
            {pill}
          </Tooltip>
        ) : (
          pill
        );
      })}
    </span>
  );
}
